'use strict';

var cov_jgp6eotch = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\routes.js',
      hash = '8dfc5fb56cceb13aa42996359065ac4935658f39',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 39,
          column: 24
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 81
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 74
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 10,
          column: 7
        }
      },
      '4': {
        start: {
          line: 7,
          column: 6
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '5': {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 8,
          column: 57
        }
      },
      '6': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 7
        }
      },
      '7': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 57
        }
      },
      '8': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 17,
          column: 7
        }
      },
      '9': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 22
        }
      },
      '10': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      '11': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 24,
          column: 9
        }
      },
      '12': {
        start: {
          line: 22,
          column: 10
        },
        end: {
          line: 22,
          column: 33
        }
      },
      '13': {
        start: {
          line: 23,
          column: 10
        },
        end: {
          line: 23,
          column: 65
        }
      },
      '14': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '15': {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 56
        }
      },
      '16': {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '17': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 35,
          column: 11
        }
      },
      '18': {
        start: {
          line: 32,
          column: 10
        },
        end: {
          line: 32,
          column: 46
        }
      },
      '19': {
        start: {
          line: 33,
          column: 10
        },
        end: {
          line: 33,
          column: 51
        }
      },
      '20': {
        start: {
          line: 34,
          column: 10
        },
        end: {
          line: 34,
          column: 52
        }
      },
      '21': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 52
        }
      },
      '22': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 36
        }
      },
      '23': {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 164,
          column: 7
        }
      },
      '24': {
        start: {
          line: 67,
          column: 10
        },
        end: {
          line: 69,
          column: 13
        }
      },
      '25': {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 32
        }
      },
      '26': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 85,
          column: 13
        }
      },
      '27': {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 84,
          column: 32
        }
      },
      '28': {
        start: {
          line: 95,
          column: 26
        },
        end: {
          line: 98,
          column: 11
        }
      },
      '29': {
        start: {
          line: 99,
          column: 25
        },
        end: {
          line: 102,
          column: 11
        }
      },
      '30': {
        start: {
          line: 103,
          column: 10
        },
        end: {
          line: 106,
          column: 13
        }
      },
      '31': {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 105,
          column: 32
        }
      },
      '32': {
        start: {
          line: 135,
          column: 10
        },
        end: {
          line: 137,
          column: 13
        }
      },
      '33': {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 31
        }
      },
      '34': {
        start: {
          line: 150,
          column: 26
        },
        end: {
          line: 153,
          column: 11
        }
      },
      '35': {
        start: {
          line: 154,
          column: 25
        },
        end: {
          line: 157,
          column: 11
        }
      },
      '36': {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 161,
          column: 13
        }
      },
      '37': {
        start: {
          line: 160,
          column: 12
        },
        end: {
          line: 160,
          column: 32
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 7
          },
          end: {
            line: 3,
            column: 8
          }
        },
        loc: {
          start: {
            line: 3,
            column: 104
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 39
          },
          end: {
            line: 6,
            column: 40
          }
        },
        loc: {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 10,
            column: 5
          }
        },
        line: 6
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 12,
            column: 39
          },
          end: {
            line: 12,
            column: 40
          }
        },
        loc: {
          start: {
            line: 12,
            column: 44
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 12
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 15,
            column: 45
          },
          end: {
            line: 15,
            column: 46
          }
        },
        loc: {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 15
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 19,
            column: 28
          },
          end: {
            line: 19,
            column: 29
          }
        },
        loc: {
          start: {
            line: 19,
            column: 37
          },
          end: {
            line: 25,
            column: 7
          }
        },
        line: 19
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 28,
            column: 47
          },
          end: {
            line: 28,
            column: 48
          }
        },
        loc: {
          start: {
            line: 28,
            column: 53
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 28
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 31,
            column: 39
          },
          end: {
            line: 31,
            column: 40
          }
        },
        loc: {
          start: {
            line: 31,
            column: 50
          },
          end: {
            line: 35,
            column: 9
          }
        },
        line: 31
      },
      '7': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 21
          }
        },
        loc: {
          start: {
            line: 42,
            column: 77
          },
          end: {
            line: 165,
            column: 1
          }
        },
        line: 42
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 66,
            column: 71
          },
          end: {
            line: 66,
            column: 72
          }
        },
        loc: {
          start: {
            line: 66,
            column: 111
          },
          end: {
            line: 70,
            column: 9
          }
        },
        line: 66
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 67,
            column: 89
          },
          end: {
            line: 67,
            column: 90
          }
        },
        loc: {
          start: {
            line: 67,
            column: 100
          },
          end: {
            line: 69,
            column: 11
          }
        },
        line: 67
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 82,
            column: 58
          },
          end: {
            line: 82,
            column: 59
          }
        },
        loc: {
          start: {
            line: 82,
            column: 98
          },
          end: {
            line: 86,
            column: 9
          }
        },
        line: 82
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 83,
            column: 89
          },
          end: {
            line: 83,
            column: 90
          }
        },
        loc: {
          start: {
            line: 83,
            column: 100
          },
          end: {
            line: 85,
            column: 11
          }
        },
        line: 83
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 94,
            column: 65
          },
          end: {
            line: 94,
            column: 66
          }
        },
        loc: {
          start: {
            line: 94,
            column: 113
          },
          end: {
            line: 107,
            column: 9
          }
        },
        line: 94
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 103,
            column: 64
          },
          end: {
            line: 103,
            column: 65
          }
        },
        loc: {
          start: {
            line: 103,
            column: 75
          },
          end: {
            line: 106,
            column: 11
          }
        },
        line: 103
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 134,
            column: 39
          },
          end: {
            line: 134,
            column: 40
          }
        },
        loc: {
          start: {
            line: 134,
            column: 65
          },
          end: {
            line: 138,
            column: 9
          }
        },
        line: 134
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 135,
            column: 65
          },
          end: {
            line: 135,
            column: 66
          }
        },
        loc: {
          start: {
            line: 135,
            column: 75
          },
          end: {
            line: 137,
            column: 11
          }
        },
        line: 135
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 149,
            column: 65
          },
          end: {
            line: 149,
            column: 66
          }
        },
        loc: {
          start: {
            line: 149,
            column: 113
          },
          end: {
            line: 162,
            column: 9
          }
        },
        line: 149
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 158,
            column: 64
          },
          end: {
            line: 158,
            column: 65
          }
        },
        loc: {
          start: {
            line: 158,
            column: 75
          },
          end: {
            line: 161,
            column: 11
          }
        },
        line: 158
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }, {
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }],
        line: 7
      },
      '1': {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }],
        line: 20
      },
      '2': {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 99
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 55
          }
        }, {
          start: {
            line: 20,
            column: 59
          },
          end: {
            line: 20,
            column: 99
          }
        }],
        line: 20
      },
      '3': {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }, {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }],
        line: 30
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_jgp6eotch.s[0]++;
angular.module('app').run(function ($rootScope, $state, $anchorScroll, $transitions, $http, apiOpen, myVars, PageViews, $window) {
  cov_jgp6eotch.f[0]++;
  cov_jgp6eotch.s[1]++;

  $rootScope.base64Key = CryptoJS.enc.Base64.parse('51oc7lWGNg/W2Rs7CGUdCQ==');
  cov_jgp6eotch.s[2]++;
  $rootScope.iv = CryptoJS.enc.Base64.parse('o/U1KF39hmtaui8/B+kP8w==');
  cov_jgp6eotch.s[3]++;
  document.addEventListener('keyup', function (e) {
    cov_jgp6eotch.f[1]++;
    cov_jgp6eotch.s[4]++;

    if (e.keyCode === 27) {
      cov_jgp6eotch.b[0][0]++;
      cov_jgp6eotch.s[5]++;

      $rootScope.$broadcast('escapePressed', e.target);
    } else {
      cov_jgp6eotch.b[0][1]++;
    }
  });

  cov_jgp6eotch.s[6]++;
  document.addEventListener('click', function (e) {
    cov_jgp6eotch.f[2]++;
    cov_jgp6eotch.s[7]++;

    $rootScope.$broadcast('documentClicked', e.target);
  });
  cov_jgp6eotch.s[8]++;
  $rootScope.$on('$locationChangeSuccess', function () {
    cov_jgp6eotch.f[3]++;
    cov_jgp6eotch.s[9]++;

    $anchorScroll();
  });
  cov_jgp6eotch.s[10]++;
  $transitions.onSuccess({ to: '*', from: '*' }, function (trans) {
    cov_jgp6eotch.f[4]++;
    cov_jgp6eotch.s[11]++;

    if ((cov_jgp6eotch.b[2][0]++, angular.equals(trans.$to().name, 'chitiet')) || (cov_jgp6eotch.b[2][1]++, angular.equals(trans.$to().name, 'view'))) {
      cov_jgp6eotch.b[1][0]++;
      cov_jgp6eotch.s[12]++;

      // PageViews.add(trans.$to().name);
      PageViews.add('views');
      cov_jgp6eotch.s[13]++;
      $rootScope.pageViews = PageViews.get(trans.$to().name);
    } else {
      cov_jgp6eotch.b[1][1]++;
    }
  });
  cov_jgp6eotch.s[14]++;
  $transitions.onStart({ to: '*', from: '*' }, function () {
    cov_jgp6eotch.f[5]++;
    cov_jgp6eotch.s[15]++;

    $rootScope.is_mobile = $window.innerWidth < 480;
    cov_jgp6eotch.s[16]++;
    if (myVars.login !== 1) {
      cov_jgp6eotch.b[3][0]++;
      cov_jgp6eotch.s[17]++;

      return $http.get(apiOpen).then(function (results) {
        cov_jgp6eotch.f[6]++;
        cov_jgp6eotch.s[18]++;

        myVars.msisdn = results.data.msisdn;
        cov_jgp6eotch.s[19]++;
        myVars.checkMember = results.data.status;
        cov_jgp6eotch.s[20]++;
        myVars.packageid = results.data.packageid;
      });
    } else {
      cov_jgp6eotch.b[3][1]++;
    }
  });
}).config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  cov_jgp6eotch.f[7]++;
  cov_jgp6eotch.s[21]++;

  $locationProvider.html5Mode(true).hashPrefix('!');
  cov_jgp6eotch.s[22]++;
  $urlRouterProvider.otherwise('/');

  cov_jgp6eotch.s[23]++;
  $stateProvider.state('app', {
    url: '/',
    component: 'app'
    // resolve: {
    //   clipsData: ['apiOpen', '$http', '$stateParams', function (apiOpen, $http, $stateParams) {
    //     return $http.get(apiOpen + 'clips/getFeatured').then(results => {
    //       return results.data;
    //     });
    //   }]
    // }
  }).state('print', {
    url: '/print',
    component: 'print'
  }).state('danhmuc', {
    url: '/the-loai/:title/:categorieid',
    component: 'categories',
    resolve: {
      categoriesData: ['apiOpen', '$http', '$stateParams', 'myVars', function (apiOpen, $http, $stateParams) {
        cov_jgp6eotch.f[8]++;
        cov_jgp6eotch.s[24]++;

        return $http.get(apiOpen + 'categories/find/' + $stateParams.categorieid).then(function (results) {
          cov_jgp6eotch.f[9]++;
          cov_jgp6eotch.s[25]++;

          return results.data;
        });
      }]
    }
  }).state('article', {
    url: '/tin-tuc/:title/:categorieid',
    component: 'tintuc'
  }).state('chitiet', {
    url: '/chi-tiet/:title/:articleid',
    component: 'tintucview',
    resolve: {
      articleData: ['apiOpen', '$http', '$stateParams', function (apiOpen, $http, $stateParams) {
        cov_jgp6eotch.f[10]++;
        cov_jgp6eotch.s[26]++;

        return $http.get(apiOpen + 'article/getDetail/' + $stateParams.articleid).then(function (results) {
          cov_jgp6eotch.f[11]++;
          cov_jgp6eotch.s[27]++;

          return results.data;
        });
      }]
    }
  }).state('view', {
    url: '/view/:title/:clipid',
    component: 'views',
    resolve: {
      clipData: ['apiOpen', '$http', '$stateParams', 'myVars', function (apiOpen, $http, $stateParams, myVars) {
        cov_jgp6eotch.f[12]++;

        var content = (cov_jgp6eotch.s[28]++, {
          msisdn: myVars.msisdn,
          id: $stateParams.clipid
        });
        var config = (cov_jgp6eotch.s[29]++, {
          params: content,
          headers: { Accept: 'application/json' }
        });
        cov_jgp6eotch.s[30]++;
        return $http.get(apiOpen + 'clips/find', config).then(function (results) {
          cov_jgp6eotch.f[13]++;
          cov_jgp6eotch.s[31]++;

          // return $http.get(apiOpen + 'clips/find/' + $stateParams.clipid).then(results => {
          return results.data;
        });
      }]
    }
  }).state('ads', {
    url: '/ads/:package/:cpid/:mm',
    component: 'ads'
  }).state('account', {
    url: '/tai-khoan',
    component: 'account'
  }).state('csbm', {
    url: '/chinh-sach',
    component: 'csbm'
  }).state('gioithieu', {
    url: '/gioi-thieu',
    component: 'gioithieu'
  }).state('login', {
    url: '/dang-nhap',
    component: 'login'
  }).state('hdsd', {
    url: '/huong-dan-su-dung',
    component: 'hdsd',
    resolve: {
      ruleData: ['apiOpen', '$http', function (apiOpen, $http) {
        cov_jgp6eotch.f[14]++;
        cov_jgp6eotch.s[32]++;

        return $http.get(apiOpen + 'content/find/policy').then(function (result) {
          cov_jgp6eotch.f[15]++;
          cov_jgp6eotch.s[33]++;

          return result.data;
        });
      }]
    }
  }).state('dstt', {
    url: '/danh-sach-trung-thuong',
    component: 'dstt'
  }).state('secureview', {
    url: '/video/:title/:clipid',
    component: 'secureview',
    resolve: {
      clipData: ['apiOpen', '$http', '$stateParams', 'myVars', function (apiOpen, $http, $stateParams, myVars) {
        cov_jgp6eotch.f[16]++;

        var content = (cov_jgp6eotch.s[34]++, {
          msisdn: myVars.msisdn,
          id: $stateParams.clipid
        });
        var config = (cov_jgp6eotch.s[35]++, {
          params: content,
          headers: { Accept: 'application/json' }
        });
        cov_jgp6eotch.s[36]++;
        return $http.get(apiOpen + 'clips/find', config).then(function (results) {
          cov_jgp6eotch.f[17]++;
          cov_jgp6eotch.s[37]++;

          // return $http.get(apiOpen + 'clips/find/' + $stateParams.clipid).then(results => {
          return results.data;
        });
      }]
    }
  });
}